import { authGet } from "@api";

import { SlackAppRedirectResponse } from "@pages/settings/types";

export const slackAppRedirect = (
  deploymentId: string
): Promise<SlackAppRedirectResponse> => {
  const url = `/api/agent/deployments/${deploymentId}/slack/install`;
  return authGet<SlackAppRedirectResponse>(url);
};
